import React, { useEffect, useState } from 'react';
import './styles.css';
import { SiteNav } from './Nav';
import { FooterCta, HomeView } from './sections';
import { CasesView, TeamView, TechView } from './views';

export default function App({ logo_url, initialView = 'home', theme = 'split-navy' } = {}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isNavScrolled, setIsNavScrolled] = useState(false);
  const [headerOffset, setHeaderOffset] = useState(() => {
    if (typeof document === 'undefined') return 0;
    const header = document.getElementById('application-header');
    return header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
  });

  const [currentView, setCurrentView] = useState(initialView);

  const navigateTo = (view) => {
    setCurrentView(view);
    setMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const header = document.getElementById('application-header');
    const update = () => {
      if (header) {
        setHeaderOffset(Math.max(0, header.getBoundingClientRect().bottom));
      }
      setIsNavScrolled(window.scrollY > 12);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  useEffect(() => {
    if (!mobileMenuOpen) return undefined;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setMobileMenuOpen(false);
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [mobileMenuOpen]);

  return (
    <div
      data-cq-theme={theme}
      className="min-h-screen bg-[#060606] text-slate-50 font-sans overflow-x-hidden selection:bg-brand/30 selection:text-white"
    >
      <SiteNav
        currentView={currentView}
        onNavigate={navigateTo}
        logoUrl={logo_url}
        isNavScrolled={isNavScrolled}
        headerOffset={headerOffset}
        mobileMenuOpen={mobileMenuOpen}
        onMobileMenuChange={setMobileMenuOpen}
      />

      <main key={currentView} className="page-transition min-h-screen">
        {currentView === 'home' && <HomeView />}
        {currentView === 'tech' && <TechView />}
        {currentView === 'team' && <TeamView />}
        {currentView === 'cases' && <CasesView />}
      </main>

      <FooterCta />
    </div>
  );
}
